import { useState, useEffect } from 'react'
import { supabase } from '../utils/supabase'

export interface ContactInfo {
  address: string
  phone: string
  email: string
  hours: string
  whatsapp?: string
}

const defaultContactInfo: ContactInfo = {
  address: 'Thamel, Kathmandu, Nepal',
  phone: '+977-1-4567890',
  email: 'info@nwlc.edu.np',
  hours: 'Sun-Fri: 9:00 AM - 6:00 PM',
  whatsapp: ''
}

export const useContactInfo = () => {
  const [contactInfo, setContactInfo] = useState<ContactInfo>(defaultContactInfo)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchContactInfo = async () => {
    try {
      setLoading(true)
      setError(null)

      const { data, error: fetchError } = await supabase
        .from('site_content')
        .select('*')
        .eq('section', 'contact')

      if (fetchError) {
        throw fetchError
      }

      if (data && data.length > 0) {
        const contactData: Partial<ContactInfo> = {}
        
        data.forEach((item: any) => {
          if (item.key in defaultContactInfo) {
            contactData[item.key as keyof ContactInfo] = item.value
          }
        })

        setContactInfo({ ...defaultContactInfo, ...contactData })
      }
    } catch (err) {
      console.error('Error fetching contact info:', err)
      setError(err instanceof Error ? err.message : 'Failed to fetch contact info')
      setContactInfo(defaultContactInfo)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchContactInfo()
  }, [])

  return {
    contactInfo,
    loading,
    error,
    fetchContactInfo
  }
}

export default useContactInfo
